import { Component, ChangeEvent } from "react";
import "./App.css";

interface State {
    digest: bigint;
    first_name: string;
    last_name: string;
    birthdate: Date | null;
    toggle: boolean;
}

interface ItemState {
    active: boolean;
}

interface ItemProps {
    content: string;
    // changed: boolean;
}

async function sha256(data: Uint8Array): Promise<Uint8Array> {
    const digest = await crypto.subtle.digest("SHA-256", data);

    return new Uint8Array(digest);
}

class SpanItem extends Component<ItemProps, ItemState> {
    state: ItemState;

    constructor(props: ItemProps) {
        super(props);
        this.state = {
            active: true,
        };
    }

    componentDidUpdate() {
        this.setState({
            active: !this.state.active,
        });
    }

    render() {
        return (
            <span className={this.state.active ? "highlight" : "none"}>
                {this.props.content}
            </span>
        );
    }
}

class App extends Component {
    state: State;

    constructor(props: any) {
        super(props);
        this.state = {
            digest: BigInt(0),
            first_name: "",
            last_name: "",
            birthdate: null,
            toggle: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    static format(
        first_name: string,
        last_name: string,
        birthdate: Date | null
    ): string {
        if (!first_name && !last_name && !birthdate) {
            return "";
        }

        let split = (name: string, seps: string[]): string => {
            if (!name) {
                return "";
            }
            let result: string = name;
            let other: string[];
            for (const sep of seps) {
                [result, ...other] = result.split(sep, 1);
            }
            return result;
        };

        let fname: string = split(first_name.toUpperCase().normalize("NFD"), [
            " ",
            ",",
        ]).trim();
        let lname: string = last_name.toUpperCase().normalize("NFD").trim();
        let bdate: string = "";

        if (birthdate) {
            const month: string = (birthdate.getMonth() + 1)
                .toString()
                .padStart(2, "0");
            const day: string = birthdate.getDate().toString().padStart(2, "0");
            const year: string = birthdate
                .getFullYear()
                .toString()
                .padStart(4, "0");
            bdate = `${year}-${month}-${day}`;
        }

        return `${fname}.${lname}.${bdate}`;
    }

    static async h(
        first_name: string,
        last_name: string,
        birthdate: Date | null
    ): Promise<bigint> {
        console.log("'" + App.format(first_name, last_name, birthdate) + "'");
        const data: Uint8Array = new TextEncoder().encode(
            App.format(first_name, last_name, birthdate)
        );
        const digest: Uint8Array = await sha256(data);
        const view: DataView = new DataView(digest.slice(0, 8).buffer);

        return view.getBigUint64(0, true);
    }

    handleChange(event: ChangeEvent<HTMLInputElement>) {
        const value = event.target.value;

        let first_name: string = this.state.first_name;
        let last_name: string = this.state.last_name;
        let birthdate: Date | null = this.state.birthdate;

        if (event.target.name === "first_name") {
            first_name = value ? value.trim() : "";
        } else if (event.target.name === "last_name") {
            last_name = value ? value.trim() : "";
        } else if (event.target.name === "birthdate") {
            birthdate = value ? new Date(value) : null;
        } else {
            throw Error("Unknown name field!");
        }

        App.h(first_name, last_name, birthdate).then((digest) => {
            this.setState({
                digest: digest,
                first_name: first_name,
                last_name: last_name,
                birthdate: birthdate,
                toggle: !this.state.toggle,
            });
        });
    }

    render() {
        const input: string = App.format(
            this.state.first_name,
            this.state.last_name,
            this.state.birthdate
        );
        const output: string = this.state.digest.toString();
        const [first_name, last_name, birthdate, ...rest] = input.split(".");

        return (
            <div className="app">
                <input
                    type="text"
                    name="first_name"
                    id="firstname"
                    placeholder="Prénom"
                    onChange={this.handleChange}
                />
                <br />
                <input
                    type="text"
                    name="last_name"
                    id="lastname"
                    placeholder="Nom"
                    onChange={this.handleChange}
                />
                <br />
                <input
                    type="date"
                    name="birthdate"
                    id="birthdate"
                    placeholder="Date de naissance"
                    onChange={this.handleChange}
                />
                <br />
                <div className="boxed">
                    <strong>
                        h(
                        <span
                            className={this.state.toggle ? "highlight" : "none"}
                        >
                            {first_name}
                        </span>
                        .
                        <span
                            className={this.state.toggle ? "highlight" : "none"}
                        >
                            {last_name}
                        </span>
                        .
                        <span
                            className={this.state.toggle ? "highlight" : "none"}
                        >
                            {birthdate}
                        </span>
                        ) ={" "}
                        <span
                            className={this.state.toggle ? "highlight" : "none"}
                        >
                            {output}
                        </span>
                    </strong>
                </div>
            </div>
        );
    }
}

export default App;
